import { render, staticRenderFns } from "./BaseNews.vue?vue&type=template&id=0e71af10&scoped=true&"
import script from "./BaseNews.vue?vue&type=script&lang=js&"
export * from "./BaseNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71af10",
  null
  
)

export default component.exports